import { render, staticRenderFns } from "./ed-youtube-video.component.vue?vue&type=template&id=178b4bc8&"
import script from "./ed-youtube-video.component.ts?vue&type=script&lang=ts&"
export * from "./ed-youtube-video.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports